




































































import { Component, Mixins } from "vue-property-decorator";
import { translate } from "@/utils";
import FormValidator from "@/mixins/FormValidator";
import { AuthService } from "@/services/auth.service";

@Component({})
export default class AuthView extends Mixins(FormValidator) {
  formRef = "form";
  error: ApiMessageObject | null = null;

  showPassword: boolean = false;
  login: string = "";
  password: string = "";
  EnterDisable: boolean = false;

  get errorMessage() {
    return translate(this.error)?.name;
  }
  public async authenticate() {
    try {
      if (!this.validateForm()) return;
      this.EnterDisable = true;

      const { result } = await AuthService.signInLogin(
        this.login,
        this.password,
        await this.recaptcha("/signin_login"),
      );

      if (typeof result != "boolean") {
        this.error = result;
        this.EnterDisable = false;
      } else if (result) {
        this.EnterDisable = false;
        this.$router.push({ name: "account-list" });
      }
    } finally {
      this.EnterDisable = false;
    }
  }

  async recaptcha(action: string) {
    await this.$recaptchaLoaded();
    return await this.$recaptcha(action);
  }

  public async loginn() {
    this.authenticate();
  }

  public async openReg() {
    this.$router.push({ name: "registration" });
  }

  public async openForgotPasswordPage() {
    this.$router.push({ name: "ForgotPassword" });
  }
}
